var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-w-7xl mx-auto px-6 lg:px-8"},[_c('PageTitle',{attrs:{"title":_vm.title,"admin":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }